/**
 * Stripe Checkout cannot run inside an iframe. When ticketing is embedded,
 * navigate the host page instead of the iframe that initiated the payment.
 */
const redirectToTopLevel = (url) => {
  if (!url) return;

  try {
    if (window.top && window.top !== window.self) {
      window.top.location.href = url;
      return;
    }
  } catch {
    // A sandboxed integration can refuse top-level navigation. Fall back to
    // the current window so the browser still has a deterministic redirect.
  }

  window.location.href = url;
};

export default redirectToTopLevel;
